module.exports = __webpack_public_path__ + "static/media/homepage-dots.3a597858.svg";